<template>
  <div v-if="visible" class="document">
    <div class="document-header card mb-3 p-3">
      <ncs-context-document-header :document="result.document"/>
    </div>
    <ul class="list-group">
      <li v-for="text in result.texts" class="list-group-item" v-html="text.source_text"></li>
    </ul>
  </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState({
      visible: s => s.api.resultDisplay === 'document',
      executionState: s => s.api.executionState,
      result: s => s.api.result
    })
  }
}
</script>